
const state = {
  header: true,
  ismobile:false
};
if (isMobileFun()) {
  //移动端
  state.ismobile=true
} else {
  //PC端
  state.ismobile=false
}
 function isMobileFun(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}
const mutations = {
  SHOW_FOOTER(state) {
    state.header = true;
  },
  HIDE_FOOTER(state) {
    state.header = false;
  }
};

export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js